import React from "react";
import { withTranslation } from 'react-i18next';

import Button from 'components/CustomButtons/Button';
import CloseButton from "assets/img/buttons/delete.svg";
import Dialog from "@material-ui/core/Dialog";
import MuiDialogTitle from "@material-ui/core/DialogTitle";
import Typography from '@material-ui/core/Typography';
import IconButton from '@material-ui/core/IconButton';

import './style.scss';

class WarningDialog extends React.Component {

  cancelButtonRef = React.createRef();

  componentDidMount() {
    this.focusCancelButton();
  }

  focusCancelButton = () => {
    setTimeout(() => {
      if (this.cancelButtonRef && this.cancelButtonRef.current) {
        this.cancelButtonRef.current.focus();
      }
    }, 200);
  }

  render() {
    const {
      isOpen,
      title,
      text,
      buttonText,
      onClose,
      onCancel,
      onConfirm,
      t
    } = this.props;
    return (
      <Dialog
        maxWidth={false}
        open={isOpen}
        PaperProps={{
          classes: {
            root: 'warning-dialog',
          }
        }}
      >
        <MuiDialogTitle className="warning-position-title" disableTypography>
          <Typography variant="h6" className="dialog-title">
            { title }
          </Typography>
          {onClose ? (
            <IconButton aria-label="close" className="close-btn" onClick={onClose}>
              <img alt="file-import-close-btn" src={CloseButton}/>
            </IconButton>
          ) : null}
        </MuiDialogTitle>
        <div className="warning-position-content">
          { text }
        </div>
        <div className="warning-position-btn-container">
          <Button
            className="cancel-btn"
            onClick={onCancel}
            ref={this.cancelButtonRef}
          >
            { t('cancel').toUpperCase() }
          </Button>
          <Button
            className="create-btn"
            onClick={onConfirm}
          >
            {buttonText}
          </Button>
        </div>
      </Dialog>
    );
  }
}

export default withTranslation()(WarningDialog);
